
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Sedancabsbookinginpune() {



    const cardData =
    {
        keyword: ' Sedan Cabs Booking in Pune',
        heading: 'Skyline Cabs: Sedan Cabs Booking in Pune',
        headingDescription: 'Skyline Cabs offers smooth and affordable Sedan Cabs Booking in Pune for comfortable local and outstation travel. Whether it as a business meeting, airport transfer, or weekend getaway, our well-maintained sedan cars—like Swift Dzire, Honda Amaze, and Hyundai Aura—ensure a safe and relaxing ride. With professional drivers, flexible booking options, transparent pricing, and 24/7 customer support, Skyline Cabs is your trusted partner for sedan cab services in Pune. Book your sedan cab today and enjoy comfort, reliability, and convenience with every ride.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Sedan Cabs in Pune",
      "description": "Skyline Cabs offers reliable sedan cab services in Pune. Ideal for local travel, business trips, and family outings, our fleet of well-maintained sedan taxis ensures comfort and timely service."
    },
    {
      "name": "Best Cab Service in Pune",
      "description": "Looking for the best cab service in Pune? Skyline Cabs provides a wide range of options including sedan, SUV, and luxury vehicles with affordable pricing and professional drivers."
    },
    {
      "name": "Sedan Taxi Near Me in Pune",
      "description": "Find a sedan taxi near you in Pune with Skyline Cabs. Whether you're in the city center or nearby localities, we offer prompt and efficient sedan taxi services for your convenience."
    },
    {
      "name": "Sedan Cab Service Near Me in Pune",
      "description": "Need a sedan cab nearby? Skyline Cabs offers affordable and comfortable sedan taxis near you for local travel, outstation trips, and airport transfers in Pune."
    },
    {
      "name": "Sedan Cab Service for Outstations",
      "description": "Skyline Cabs provides sedan cab services for outstation travel from Pune to nearby cities like Nashik, Lonavala, and more. Choose our reliable services for a comfortable and economical ride."
    },
    {
      "name": "Toyota Etios Taxi in Pune",
      "description": "Book a Toyota Etios for your next trip with Skyline Cabs in Pune. Known for its comfort and fuel efficiency, the Toyota Etios is a great option for both local and outstation journeys."
    },
    {
      "name": "Toyota Etios Cab in Pune",
      "description": "Skyline Cabs offers Toyota Etios cabs in Pune, ideal for both short-distance and long-distance travel. Spacious and comfortable, these cabs are perfect for individuals or small groups."
    },
    {
      "name": "Taxi & Sedan Services Booking",
      "description": "Easily book taxi and sedan services in Pune with Skyline Cabs. Whether it's a quick ride to the airport or an outstation trip, we offer flexible booking options and competitive pricing."
    },
    {
      "name": "Sedan Taxi Service for Outstations",
      "description": "Skyline Cabs offers reliable sedan taxi services for outstation travel from Pune. Whether it's a business trip, a family vacation, or a pilgrimage, we ensure comfort and safety throughout the journey."
    },
    {
      "name": "Pune to Nashik Sedan Cab Service",
      "description": "Book a sedan for your Pune to Nashik trip with Skyline Cabs. Travel in comfort with our experienced drivers, offering a smooth and hassle-free ride to Nashik, one of the most popular pilgrimage and tourist destinations."
    }
  ],
  "tableData": [
    ["Sedan Cabs in Pune", "Best Cab Service in Pune"],
    ["Sedan Taxi Near Me in Pune", "Sedan Cab Service Near Me in Pune"],
    ["Sedan Cab Service for Outstations", "Toyota Etios Taxi in Pune"],
    ["Toyota Etios Cab in Pune", "Taxi & Sedan Services Booking"],
    ["Sedan Taxi Service for Outstations", "Pune to Nashik Sedan Cab Service"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Sedan Cab Service in Pune",
        "WhyChoosedescription": "Our sedan cab service in Pune is known for reliability and punctuality. Whether it’s for business or leisure, we ensure a smooth, comfortable, and timely ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Sedans",
        "WhyChoosedescription": "Our fleet of sedans offers ample space, air-conditioning, and a smooth ride. Enjoy a relaxing and comfortable journey throughout your travel in Pune."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-trained and knowledgeable of the best routes in Pune. They prioritize your safety and comfort while ensuring a smooth travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive pricing for sedan cab rentals in Pune, with no hidden charges. What you see is what you pay, making it a cost-effective option for your travel."
    },
    {
        "WhyChooseheading": "Flexible Booking Options",
        "WhyChoosedescription": "Whether you need a sedan cab for a few hours, a day, or for an outstation trip, we offer flexible booking options to suit your schedule and requirements."
    },
    {
        "WhyChooseheading": "24/7 Availability for Convenient Travel",
        "WhyChoosedescription": "Our sedan cabs are available 24/7 in Pune. You can book a ride at any time, whether it's an early morning airport transfer or a late-night return from a meeting."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your sedan cab is quick and simple through our website or mobile app. Enjoy instant booking confirmation and real-time tracking of your ride for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "We ensure that all our sedan cabs are thoroughly sanitized after each ride to provide a clean and safe environment for every traveler. Safety protocols are strictly followed during every journey."
    }
]
























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Sedan cab in Pune with Skyline Cabs?',
            answer:
                'Booking a Sedan cab in Pune with Skyline Cabs is quick and easy. You can book through our website, mobile app, or by calling our customer support team. Simply select Sedan as your preferred vehicle, enter your travel details, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What makes Sedan cabs a good choice for travel in Pune?',
            answer:
                'Sedan cabs are ideal for individual or small group travel. They offer a comfortable and affordable ride with a smooth driving experience. Perfect for business trips, airport transfers, and local city commutes in Pune.',
        },
        {
            id: 3,
            question: 'Are Sedan cabs available for both local and outstation trips in Pune?',
            answer:
                'Yes, Sedan cabs are available for both local travel within Pune as well as outstation trips to destinations like Mumbai, Lonavala, Mahabaleshwar, and more.',
        },
        {
            id: 4,
            question: 'Are the fares for Sedan cab bookings in Pune fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent pricing for Sedan bookings. Your fare includes driver charges, tolls, taxes, and other fees, ensuring there are no hidden charges.',
        },
        {
            id: 5,
            question: 'Can I book a Sedan cab for a one-way trip from Pune?',
            answer:
                'Yes, you can easily book a one-way Sedan cab from Pune to any major city. Just specify your destination when making the booking.',
        },
        {
            id: 6,
            question: 'Is it possible to book a Sedan cab for corporate travel in Pune?',
            answer:
                'Absolutely! Sedan cabs are perfect for corporate travel, offering a comfortable and professional experience for business meetings, airport transfers, and more.',
        },
        {
            id: 7,
            question: 'Are the Sedan cabs clean and well-maintained?',
            answer:
                'Yes, all our Sedan cabs are regularly cleaned, sanitized, and maintained to provide a safe and comfortable journey. We take hygiene and vehicle upkeep very seriously.',
        },
        {
            id: 8,
            question: 'What payment options are available for Sedan cab bookings in Pune?',
            answer:
                'We offer multiple payment options, including secure online payments via UPI, credit/debit cards, net banking, or cash payments at the end of your ride.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Sedan cab booking in Pune?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, app, or by contacting our customer support team. We offer flexible terms to accommodate changes to your travel plans.',
        },
        {
            id: 10,
            question: 'Why should I book a Sedan cab with Skyline Cabs in Pune?',
            answer:
                'Skyline Cabs offers reliable, punctual, and affordable Sedan cab services. With well-maintained vehicles, professional drivers, and no hidden charges, we ensure a smooth and hassle-free journey every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked a Sedan cab for a business trip in Pune. The ride was smooth, the driver was professional, and the car was clean. Very satisfied with the service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a pleasant experience with Skyline Cabs. The Sedan was perfect for my solo trip around Pune. The booking process was smooth, and the driver was punctual. Would recommend!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cabs Booking in Pune",
  "image": "https://skylinecabs.com/assets/images/sedan-cabs-booking-pune.jpg",
  "description": "Book Sedan cabs in Pune with Skyline Cabs for comfortable, clean, and budget-friendly travel. Ideal for daily commute, airport transfers, and intercity rides — available 24/7 with trained drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7684"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/sedan-cabs-booking-in-pune"
  }
};



      
      
      

    return (
        <div>

<Helmet>
  <title>Sedan Cabs Booking in Pune | Clean & Comfortable Ride 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Sedan cabs in Pune with Skyline Cabs for comfortable, clean, and budget-friendly travel. Ideal for daily commute, airport transfers, and intercity rides — available 24/7 with trained drivers." 
  />
  <meta 
    name="keywords" 
    content="Sedan Cabs Booking in Pune, Book Sedan Cab Pune, Affordable Sedan Taxi Pune, AC Sedan Cab Pune, Airport Sedan Pune, Pune Outstation Sedan Cab, Sedan Cab Hire Pune, Dzire Cab Booking Pune, Skyline Cabs Sedan Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/75.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Sedancabsbookinginpune;